import type { CaseStatus, FlowType } from '@/features/cases/types'

/**
 * Flow-specific pipeline labels — the `trades` flow relabels step 4 "Trade Audit Ready" instead
 * of the generic "Audit Ready" the `audit` flow uses. Extracted from `review-status-view.tsx` so
 * the public `/status/[trackingToken]` page and the authenticated review-status page share one
 * source of truth instead of two copies that could silently drift.
 */
export const CASE_STATUS_PIPELINE_BY_FLOW: Record<FlowType, { key: CaseStatus; label: string }[]> =
  {
    audit: [
      { key: 'submitted', label: 'Submitted' },
      { key: 'consultation_scheduled', label: 'Consultation Scheduled' },
      { key: 'consultation_completed', label: 'Consultation Completed' },
      { key: 'audit_ready', label: 'Audit Ready' },
      { key: 'published', label: 'Published' },
    ],
    trades: [
      { key: 'submitted', label: 'Submitted' },
      { key: 'consultation_scheduled', label: 'Consultation Scheduled' },
      { key: 'consultation_completed', label: 'Consultation Completed' },
      { key: 'audit_ready', label: 'Trade Audit Ready' },
      { key: 'published', label: 'Published' },
    ],
    build: [
      { key: 'submitted', label: 'Submitted' },
      { key: 'consultation_scheduled', label: 'Consultation Scheduled' },
      { key: 'consultation_completed', label: 'Consultation Completed' },
      { key: 'audit_ready', label: 'Plan Ready' },
      { key: 'published', label: 'Published' },
    ],
  }
